var map = {
	"./alert_fill.svg": 31838,
	"./apple_store.svg": 1139,
	"./backgrounds/bg_day.svg": 80875,
	"./backgrounds/bg_day_big.svg": 4767,
	"./backgrounds/bg_night.svg": 78259,
	"./backgrounds/bg_night_big.svg": 71682,
	"./backgrounds/day-stork-bg-1366x768.svg": 51009,
	"./backgrounds/day-stork-bg-1920x1080.svg": 421,
	"./backgrounds/day-stork-bg-2560x1600.svg": 61748,
	"./backgrounds/night-stork-bg-1366x768.svg": 41664,
	"./backgrounds/night-stork-bg-1920x1080.svg": 83241,
	"./backgrounds/night-stork-bg-2560x1600.svg": 37800,
	"./check_circle.svg": 60450,
	"./close.svg": 48750,
	"./conection_error.svg": 21813,
	"./default-image-form.svg": 61685,
	"./error_user.svg": 85384,
	"./error_warn.svg": 68502,
	"./generic_error.svg": 91591,
	"./google_icon.svg": 98489,
	"./google_play.svg": 69394,
	"./icons_eye.svg": 486,
	"./img-torre-2.svg": 93267,
	"./img-torre-3.svg": 99406,
	"./img-torre.svg": 64006,
	"./invitation_error.svg": 91033,
	"./invitation_error_expired.svg": 98775,
	"./logo_claro.svg": 84802,
	"./logo_fleetcare.svg": 27567,
	"./logo_mindy.svg": 26084,
	"./logo_oms.svg": 95231,
	"./logo_qm_flash.svg": 75203,
	"./logo_qm_flash_white.svg": 29009,
	"./logo_qm_saas.svg": 60576,
	"./logo_qm_saas_white.svg": 46536,
	"./logo_quadmindsAI.svg": 71176,
	"./logo_tdc.svg": 6299,
	"./logo_tdc_night.svg": 75975,
	"./logo_tdc_white.svg": 77514,
	"./mockup_app_bienvenida.svg": 29852,
	"./mockup_entregas.svg": 12266,
	"./mockup_entregas3.svg": 77802,
	"./mockup_manager_app.svg": 49831,
	"./success.svg": 90564,
	"./torre-ghost.svg": 52314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40968;